import { svelteHelpers } from "@propublica/pp-frontend";

import * as components from "./svelte-components.js";

// @ts-ignore (TODO(@alecglassford): Fix type problems with components)
svelteHelpers.hydrateAllComponentsOnPage(components);

// Add your code here! (or write other JS modules and use their imports here)
